import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { giftsRedeemedByParticipant } from 'redux/Reducers/Gift/GiftApi';
import { useNotifications } from 'Shared/Notification';
import useActiveCampaign from 'Hooks/useVertemGift';
import ynToBool from 'Utils/ynToBool';

const useGiftCardParticipant = () => {
  const { isCampaignActive } = useActiveCampaign();

  const dispatch = useDispatch();
  const { participantGroups: participantGroupData, isLoadingParticipantGroups } = useSelector(
    (state) => state.ParticipantGroups,
  );
  const { hasAcceptedTerm, availableBallons, ballonsByParticipant } = useSelector(
    (state) => state.VertemGift,
  );

  const {
    giftInfo: giftsActiveOnCampaign,
    isLoadingProducts: isLoadingGiftsActiveByCampaign,
    redeemedGifts,
    totalInventoryOfProducts,
    participantHasAccessedGiftOrClosedInformativeModal,
  } = useSelector((state) => state.Gift);
  const { addNotification, checkIfNotificationExist, getNotificationByName } = useNotifications();

  const [isBannerOfGiftsVisible, setIsBannerOfGiftsVisible] = useState(false);
  const [isModalOfGiftsVisible, setIsModalOfGiftsVisible] = useState(false);
  const [isInformativeOfVertemGiftsVisible, setIsInformativeOfVertemGiftsVisible] = useState(false);

  useEffect(() => {
    if (
      participantGroupData &&
      Array.isArray(participantGroupData) &&
      participantGroupData.length > 0 &&
      giftsActiveOnCampaign &&
      Array.isArray(giftsActiveOnCampaign.groups) &&
      giftsActiveOnCampaign.groups.length > 0
    ) {
      const isParticipantOnGroupOfGiftCampaign = participantGroupData.some((item) =>
        giftsActiveOnCampaign.groups.includes(item.name),
      );
      const isThereProductsOnStock = totalInventoryOfProducts > 0;
      const giftWasRedeemed = Array.isArray(redeemedGifts) && redeemedGifts.length > 0;
      if (
        isParticipantOnGroupOfGiftCampaign &&
        isThereProductsOnStock &&
        !checkIfNotificationExist('Brinde_Resgatar')
      ) {
        addNotification('Brinde_Resgatar', {
          title: 'Você tem um brinde para resgatar!',
          message: 'Aproveite antes que expire!',
          date: new Intl.DateTimeFormat('pt-BR').format(new Date()),
          read: giftWasRedeemed,
          href: '/gift',
          hrefText: 'Resgatar agora',
        });
      }
      setIsBannerOfGiftsVisible(
        isParticipantOnGroupOfGiftCampaign && isThereProductsOnStock && !giftWasRedeemed,
      );
      setIsModalOfGiftsVisible(
        !participantHasAccessedGiftOrClosedInformativeModal &&
          isParticipantOnGroupOfGiftCampaign &&
          isThereProductsOnStock &&
          !giftWasRedeemed,
      );
    }
  }, [
    participantGroupData,
    giftsActiveOnCampaign,
    isLoadingGiftsActiveByCampaign,
    isLoadingParticipantGroups,
    totalInventoryOfProducts,
    giftsRedeemedByParticipant,
    redeemedGifts,
    addNotification,
  ]);

  useEffect(() => {
    if (ynToBool(process.env.REACT_APP_HAS_VERTEM_GIFT)) {
      const timeoutId = setTimeout(() => {
        const areVariablesDefined =
          availableBallons != null && ballonsByParticipant != null && hasAcceptedTerm != null;

        const isTermAccepted = hasAcceptedTerm === true;

        const hasAvailableBalloons = availableBallons?.length > 0;

        const hasBalloonWithStatus2 = ballonsByParticipant?.some((balloon) => balloon.status === 2);

        if (
          areVariablesDefined &&
          isTermAccepted &&
          (hasAvailableBalloons || hasBalloonWithStatus2)
        ) {
          setIsInformativeOfVertemGiftsVisible(true);
        } else {
          setIsInformativeOfVertemGiftsVisible(false);
        }
      }, 3000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [availableBallons, ballonsByParticipant, hasAcceptedTerm, isCampaignActive]);

  useEffect(() => {
    giftsActiveOnCampaign?._id && dispatch(giftsRedeemedByParticipant(giftsActiveOnCampaign?._id));
    if (
      giftsActiveOnCampaign?._id &&
      checkIfNotificationExist('Brinde_Resgatar') &&
      !getNotificationByName('Brinde_Resgatar').toJSON().read
    ) {
      addNotification('Brinde_Resgatar', {
        title: 'Você tem um brinde para resgatar!',
        message: 'Aproveite antes que expire!',
        date: new Intl.DateTimeFormat('pt-BR').format(new Date()),
        read: true,
      });
    }
  }, [giftsActiveOnCampaign]);

  return {
    isBannerOfGiftsVisible,
    setIsModalOfGiftsVisible,
    isModalOfGiftsVisible,
    isInformativeOfVertemGiftsVisible,
    setIsInformativeOfVertemGiftsVisible,
  };
};

export default useGiftCardParticipant;
